module.exports = __webpack_public_path__ + "static/media/ic-ride.4492b1d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ic-ride.svg
// module id = 656
// module chunks = 14